module.exports = __webpack_public_path__ + "img/key.29c1e8f0.png";